// import React, { useState, useRef, useEffect } from 'react';
// import './FilterProduct.css';
// import { FiFilter } from 'react-icons/fi';

// const FilterProduct = ({
//   selectedStartDate,
//   selectedEndDate,
//   selectedMonth,
//   selectedYear,
//   onDateRangeSelected,
//   onMonthSelected,
//   onYearSelected,
//   onClearFilters,
//   onApplyFilters
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState('Date Range');
//   const [tempStartDate, setTempStartDate] = useState(selectedStartDate);
//   const [tempEndDate, setTempEndDate] = useState(selectedEndDate);
//   const [tempMonth, setTempMonth] = useState(selectedMonth);
//   const [tempYear, setTempYear] = useState(selectedYear);
//   const selectRef = useRef(null);

//   const months = [
//     { value: '01', label: 'January' },
//     { value: '02', label: 'February' },
//     { value: '03', label: 'March' },
//     { value: '04', label: 'April' },
//     { value: '05', label: 'May' },
//     { value: '06', label: 'June' },
//     { value: '07', label: 'July' },
//     { value: '08', label: 'August' },
//     { value: '09', label: 'September' },
//     { value: '10', label: 'October' },
//     { value: '11', label: 'November' },
//     { value: '12', label: 'December' },
//   ];

//   const years = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);

//   useEffect(() => {
//     setTempStartDate(selectedStartDate);
//     setTempEndDate(selectedEndDate);
//     setTempMonth(selectedMonth);
//     setTempYear(selectedYear);
//   }, [selectedStartDate, selectedEndDate, selectedMonth, selectedYear]);

//   const handleToggle = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (selectRef.current && !selectRef.current.contains(event.target)) {
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const hasActiveFilters = () => {
//     return (selectedStartDate && selectedEndDate) || selectedMonth;
//   };

//   const getFilterCount = () => {
//     let count = 0;
//     if (selectedStartDate && selectedEndDate) count++;
//     if (selectedMonth) count++;
//     return count;
//   };

//   const handleApply = () => {
//     onApplyFilters({
//       startDate: tempStartDate,
//       endDate: tempEndDate,
//       month: tempMonth,
//       year: tempYear
//     });
//     setIsOpen(false);
//   };

//     const handleClearAll = () => {
//     setTempStartDate('');
//     setTempEndDate('');
//     setTempMonth('');
//     setTempYear(new Date().getFullYear());
//     onClearFilters(); // Call parent's clear function
//     setIsOpen(false);
//   };

//   return (
//     <div className="product-filter">
//       <div
//         className={`filter-product-header ${hasActiveFilters() ? 'has-filters' : ''}`}
//         onClick={handleToggle}
//       >
//         <FiFilter className="filter-icon" size={24} />
//         <span className="filter-placeholder">
//           Filters
//           {hasActiveFilters() && (
//             <span className="filter-count-badge">
//               {getFilterCount()}
//             </span>
//           )}
//         </span>
//       </div>

//       {isOpen && (
//         <div className="filter-product-overlay">
//           <div className="filter-product-container" ref={selectRef}>
//             <div className="filter-product-sidebar">
//               <div className="filter-product-title">Filters</div>

//               <div
//                 className={`sidebar-item ${activeSection === 'Date Range' ? 'active' : ''}`}
//                 onClick={() => setActiveSection('Date Range')}
//               >
//                 <span>Date Range</span>
//                 {(tempStartDate && tempEndDate) && (
//                   <span className="filter-badge">1</span>
//                 )}
//               </div>

//               <div
//                 className={`sidebar-item ${activeSection === 'Month' ? 'active' : ''}`}
//                 onClick={() => setActiveSection('Month')}
//               >
//                 <span>Month</span>
//                 {tempMonth && <span className="filter-badge">1</span>}
//               </div>
//             </div>

//             <div className="filter-product-content">
//               <div className="filter-footer">
//                  <button
//                 className="clear-btn"
//                 onClick={handleClearAll}
//                 disabled={!(tempStartDate || tempEndDate || tempMonth)}
//               >
//                 CLEAR ALL
//               </button>
//                 <button
//                   className="apply-btn"
//                   onClick={handleApply}
//                 >
//                   APPLY
//                 </button>
//               </div>

//               <div className="scrollable-product-content">
//                 {activeSection === 'Date Range' && (
//                   <>
//                     <div className="content-section">
//                       <div className="content-title">Date Range</div>
//                     </div>
//                     <div className="date-range-container">
//                       <div className="date-input-group">
//                         <label>From</label>
//                         <input
//                           type="date"
//                           value={tempStartDate || ''}
//                           onChange={(e) => setTempStartDate(e.target.value)}
//                         />
//                       </div>
//                       <div className="date-input-group">
//                         <label>To</label>
//                         <input
//                           type="date"
//                           value={tempEndDate || ''}
//                           onChange={(e) => setTempEndDate(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 {activeSection === 'Month' && (
//                   <>
//                     <div className="content-section">
//                       <div className="content-title">Month</div>
//                     </div>
//                     <div className="month-filter-container">
//                       <div className="year-selection">
//                         <label>Year</label>
//                         <select
//                           value={tempYear}
//                           onChange={(e) => setTempYear(e.target.value)}
//                           className="year-select"
//                         >
//                           {years.map(year => (
//                             <option key={year} value={year}>
//                               {year}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="month-buttons-container">
//                         <label>Month</label>
//                         <div className="month-buttons-grid">
//                           {months.map(month => (
//                             <button
//                               key={month.value}
//                               className={`month-button ${tempMonth === month.value ? 'selected' : ''}`}
//                               onClick={() => setTempMonth(month.value)}
//                             >
//                               {month.label}
//                             </button>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FilterProduct;

import React, { useState, useRef, useEffect } from 'react';
import {
    Checkbox,
    TextField,
    InputAdornment,
    IconButton,
    Button
} from '@mui/material';
import { FiFilter, FiSearch, FiX } from 'react-icons/fi';
import './FilterProduct.css';

const FilterProduct = ({
    selectedStartDate,
    selectedEndDate,
    selectedMonth,
    selectedYear,
    onDateRangeSelected,
    onMonthSelected,
    onYearSelected,
    onClearFilters,
    onApplyFilters,
    allConsumeproducts,
    onProductSelectionChange
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('Date Range');
    const [tempStartDate, setTempStartDate] = useState(selectedStartDate);
    const [tempEndDate, setTempEndDate] = useState(selectedEndDate);
    const [tempMonths, setTempMonths] = useState(selectedMonth ? selectedMonth.split(',') : []);
    const [tempYear, setTempYear] = useState(selectedYear);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const selectRef = useRef(null);

    const months = [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
    ];

    const years = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);

    // Filter products based on search term
    const filteredProducts = allConsumeproducts.filter(product =>
        product.consumeableProductName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        setTempStartDate(selectedStartDate);
        setTempEndDate(selectedEndDate);
        setTempMonths(selectedMonth ? selectedMonth.split(',') : []);
        setTempYear(selectedYear);
    }, [selectedStartDate, selectedEndDate, selectedMonth, selectedYear]);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const hasActiveFilters = () => {
        return (selectedStartDate && selectedEndDate) || selectedMonth || selectedProducts.length > 0;
    };

    const getFilterCount = () => {
        let count = 0;
        if (selectedStartDate && selectedEndDate) count++;
        if (selectedMonth) count++;
        if (selectedProducts.length > 0) count++;
        return count;
    };

    const handleApply = () => {
        onApplyFilters({
            startDate: tempStartDate,
            endDate: tempEndDate,
            month: tempMonths.join(','),
            year: tempYear
        });
        onProductSelectionChange(selectedProducts);
        setIsOpen(false);
    };

    const handleClearAll = () => {
        setTempStartDate('');
        setTempEndDate('');
        setTempMonths([]);
        setTempYear(new Date().getFullYear());
        setSelectedProducts([]);
        setSelectAll(false);
        setSearchTerm('');
        onClearFilters();
        onProductSelectionChange([]);
        setIsOpen(false);
    };

    // Product selection handlers
    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        if (checked) {
            const allProductIds = filteredProducts.map(product => product._id);
            setSelectedProducts(allProductIds);
        } else {
            setSelectedProducts([]);
        }
    };

    const handleProductSelect = (productId, isChecked) => {
        if (isChecked) {
            setSelectedProducts(prev => [...prev, productId]);
        } else {
            setSelectedProducts(prev => prev.filter(id => id !== productId));
            setSelectAll(false);
        }
    };
    const handleMonthToggle = (monthValue) => {
        setTempMonths(prev =>
            prev.includes(monthValue) ? prev.filter(m => m !== monthValue) : [...prev, monthValue]
        );
    };
    return (
        <div className="product-filter">
            <div
                className={`filter-product-header ${hasActiveFilters() ? 'has-filters' : ''}`}
                onClick={handleToggle}
            >
                <FiFilter className="filter-icon" size={24} />
                <span className="filter-placeholder">
                    Filters
                    {hasActiveFilters() && (
                        <span className="filter-count-badge">
                            {getFilterCount()}
                        </span>
                    )}
                </span>
            </div>

            {isOpen && (
                <div className="filter-product-overlay">
                    <div className="filter-product-container" ref={selectRef}>
                        <div className="filter-product-sidebar">
                            <div className="filter-product-title">Filters</div>

                            <div
                                className={`sidebar-item ${activeSection === 'Date Range' ? 'active' : ''}`}
                                onClick={() => setActiveSection('Date Range')}
                            >
                                <span>Date Range</span>
                                {(tempStartDate && tempEndDate) && (
                                    <span className="filter-badge">1</span>
                                )}
                            </div>

                            <div
                                className={`sidebar-item ${activeSection === 'Month' ? 'active' : ''}`}
                                onClick={() => setActiveSection('Month')}
                            >
                                <span>Month</span>
                                {tempMonths.length > 0 && (
                                    <span className="filter-badge">{tempMonths.length}</span>
                                )}
                            </div>

                            <div
                                className={`sidebar-item ${activeSection === 'Products' ? 'active' : ''}`}
                                onClick={() => setActiveSection('Products')}
                            >
                                <span>Products</span>
                                {selectedProducts.length > 0 && (
                                    <span className="filter-badge">{selectedProducts.length}</span>
                                )}
                            </div>
                        </div>

                        <div className="filter-product-content">
                            <div className="filter-footer">
                                <button
                                    className="clear-btn"
                                    onClick={handleClearAll}
                                    disabled={!(tempStartDate || tempEndDate || tempMonths || selectedProducts.length > 0)}
                                >
                                    CLEAR ALL
                                </button>
                                <button
                                    className="apply-btn"
                                    onClick={handleApply}
                                >
                                    APPLY
                                </button>
                            </div>

                            <div className="scrollable-product-content">
                                {activeSection === 'Date Range' && (
                                    <>
                                        <div className="content-section">
                                            {/* <div className="content-title">Date Range</div> */}
                                        </div>
                                        <div className="date-range-container">
                                            <div className="date-input-group">
                                                <label>From</label>
                                                <input
                                                    type="date"
                                                    value={tempStartDate || ''}
                                                    onChange={(e) => setTempStartDate(e.target.value)}
                                                />
                                            </div>
                                            <div className="date-input-group">
                                                <label>To</label>
                                                <input
                                                    type="date"
                                                    value={tempEndDate || ''}
                                                    onChange={(e) => setTempEndDate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                {activeSection === 'Month' && (
                                    <div className="month-filter-container">
                                        <div className="year-selection">
                                            <label>Year</label>
                                            <select
                                                value={tempYear}
                                                onChange={(e) => setTempYear(e.target.value)}
                                                className="year-select"
                                            >
                                                {years.map(year => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="month-buttons-container">
                                            {/* <label>Month</label> */}
                                            <div className="month-buttons-grid">
                                                {months.map(month => (
                                                    <button
                                                        type="button"
                                                        key={month.value}
                                                        className={`month-button ${tempMonths.includes(month.value) ? 'selected' : ''}`}
                                                        onClick={() => handleMonthToggle(month.value)}
                                                    >
                                                        {month.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeSection === 'Products' && (
                                    <>
                                        <div className="content-section">
                                            {/* <div className="content-title">Products</div> */}
                                        </div>
                                        <div className="product-search-container">
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                placeholder="Search products..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <FiSearch />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: searchTerm && (
                                                        <IconButton
                                                            onClick={() => setSearchTerm('')}
                                                            size="small"
                                                        >
                                                            <FiX />
                                                        </IconButton>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="product-select-all">
                                            <Checkbox
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                indeterminate={
                                                    selectedProducts.length > 0 &&
                                                    selectedProducts.length < filteredProducts.length
                                                }
                                            />
                                            <span>Select all {filteredProducts.length} products</span>
                                        </div>
                                        <div className="product-list-container">
                                            {filteredProducts.length > 0 ? (
                                                <div className="product-list">
                                                    {filteredProducts.map(product => (
                                                        <div key={product._id} className="product-item">
                                                            <Checkbox
                                                                checked={selectedProducts.includes(product._id)}
                                                                onChange={(e) => handleProductSelect(product._id, e.target.checked)}
                                                            />
                                                            <span>{product.consumeableProductName}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="no-products-found">
                                                    No products found matching your search
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FilterProduct;